import { Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './TokenUsageBanner.module.scss';

export type TokenUsageBannerProps =
  | {
      percentage: number;
      resetDate?: string;
      variant?: 'usage';
    }
  | {
      variant: 'error';
    };

export const TokenUsageBanner = (props: TokenUsageBannerProps) => {
  const { t } = useTranslation('chat');
  const isError = props.variant === 'error';
  const hasReachedLimit = !isError && props.percentage >= 100;
  const usesLockIcon = isError || hasReachedLimit;
  const getUsageMessage = () => {
    if (isError) {
      return t('chat:tokenUsage.connectionError');
    }

    let messageKey = props.resetDate
      ? 'chat:tokenUsage.milestone'
      : 'chat:tokenUsage.milestoneWithoutReset';

    if (hasReachedLimit) {
      messageKey = props.resetDate
        ? 'chat:tokenUsage.limitReached'
        : 'chat:tokenUsage.limitReachedWithoutReset';
    }

    return t(messageKey, {
      percentage: props.percentage,
      resetDate: props.resetDate,
    });
  };

  return (
    <div
      className={styles.root}
      data-testid="token-usage-banner"
      data-token-usage-banner
    >
      <Icon
        aria-hidden
        className={styles.icon}
        fillColor="var(--icon-soft)"
        iconName={usesLockIcon ? 'LockKey' : 'InformationCircle'}
        size={20}
        viewBox={usesLockIcon ? '0 0 20 20' : undefined}
      />
      <p className={styles.message}>{getUsageMessage()}</p>
    </div>
  );
};
